import React, { Component } from 'react';
import { getEmployeeCertificateList } from '../../../../utils/apiMiniWidget';
import {
  StyledBoxInside,
  // StyledWrapperSearch,
  StyledWrapperEmployerDirectory,
  StyledWrapperPaginator
  // StyledButtonClear
} from './style';
// import SearchFilterMini from '../../../core/SearchFilterMini';
import SelectEmployerWithholding from '../../../core/SelectEmployerDirectory/SelectEmployerWithholding';
import PaginatorVertical from '../../../core/PaginatorVertical';
import InfiniteScroller from '../../../core/InfiniteScroller';
import { Pills } from '../../../core/Pill';
import {
  StyledBoxInfoContent,
  StyledButton
} from '../../../views/Employee/Withholding/style';

class WithholdingEmployees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: undefined,
      // modalActive: false,
      filter: {}
    };
    this.pageCounter = 1;
  }

  componentDidMount() {
    this.getList();
  }

  getList = data =>
    getEmployeeCertificateList(data || {})
      .then(employeeData => {
        this.setState({ list: employeeData });
      })
      .catch(error => {
        console.error('Error a la hora de obtener empleados', error);
      });

  // setFilter = filter => {
  //   this.setState({
  //     filter
  //   });
  // };

  onClick = formData => () => {
    const data = formData();
    this.getList(data);
  };

  getFilters = () => this.state.filter;

  clearFilter = () => this.getList();

  nextScroll = params => {
    this.pageCounter += 1;
    this.getList(params);
  };

  // openModal = () => {
  // this.setState({ modalActive: true });
  // };
  // closeModal = () => {
  // this.setState({ modalActive: false });
  // };

  render() {
    const { list, /* modalActive, dataForm, */ filter } = this.state;
    const { resetRow, setEmployeeSelected } = this.props;
    let nextSize;
    if (list) {
      nextSize =
        list.size < list.total * (list.page + 1)
          ? list.size * (this.pageCounter + 1)
          : list.total;
    }
    return (
      <div
        className="pressResume_container"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <StyledBoxInside>
          <Pills>
            <StyledBoxInfoContent>
              <StyledButton primary isFloat margin onClick={this.clearFilter}>
                Refrescar
              </StyledButton>
            </StyledBoxInfoContent>
          </Pills>
          {/* <StyledWrapperSearch>
            {Object.keys(filter).length > 0 && (
              <StyledButtonClear onClick={this.clearFilter}>
                Borrar filtros
              </StyledButtonClear>
            )}
             <SearchFilterMini
              onClick={this.onClick}
              modalActive={modalActive}
              closeModal={this.closeModal}
              openModal={this.openModal}
              dataForm={dataForm}
              setFilter={this.setFilter}
              filter={filter}
            /> 
          </StyledWrapperSearch> */}
          <StyledWrapperEmployerDirectory>
            <InfiniteScroller
              page={list ? list.page : 0}
              loadMore={() =>
                this.nextScroll({
                  size: nextSize,
                  ...filter
                })
              }
            >
              {list && (
                <div className="Employee-wrapperTable">
                  <SelectEmployerWithholding
                    data={list.content}
                    setEmployeeSelected={setEmployeeSelected}
                    resetRow={resetRow}
                  />
                </div>
              )}
            </InfiniteScroller>
          </StyledWrapperEmployerDirectory>
          <StyledWrapperPaginator>
            {list && (
              <PaginatorVertical
                visibleItems={list.size <= list.total ? list.size : list.total}
                totalItems={list.total}
              />
            )}
          </StyledWrapperPaginator>
        </StyledBoxInside>
      </div>
    );
  }
}

export default WithholdingEmployees;
